import React from 'react';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../mock';
import BlogCard from './BlogCard';

const BlogSection = () => {
  return (
    <section id="resources" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#5DCAA5] font-semibold text-lg mb-4">Latest Insights</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2A] mb-6 tracking-tight">
            Our Resources
          </h2>
          <p className="text-lg text-[#6B6B69] max-w-3xl mx-auto">
            Stay informed with expert advice and practical tips for navigating your NDIS journey
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {mockData.blogPosts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;